import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { axiosInstance } from "../../utils/axios";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters"),
});

function AddTypeDialog({ open, handleClose, eventId, onAddType }) {
  const handleSubmit = async (
    values,
    { setSubmitting, resetForm, setStatus, setErrors }
  ) => {
    try {
      console.log("Submitting category:", values.name);

      // This creates a placeholder attendee with the category to ensure it exists
      const response = await axiosInstance.post("/graphql", {
        query: `
          mutation CreateAttendee($input: CreateAttendeeInput!) {
            createAttendee(input: $input) {
              id
              category
            }
          }
        `,
        variables: {
          input: {
            eventId,
            firstName: "__CategoryPlaceholder__",
            lastName: "__DO_NOT_USE__",
            email: `category-${values.name
              .toLowerCase()
              .replace(/\s+/g, "-")}@placeholder.com`,
            jobTitle: "Category Placeholder",
            organization: "System",
            city: "System",
            country: "System",
            addedVia: "Register",
            sendEmail: false,
            category: values.name,
          },
        },
      });

      console.log("Create category response:", response);

      if (response.errors) {
        throw new Error(
          response.errors[0]?.message || "Error creating category"
        );
      }

      if (response.data && response.data.createAttendee) {
        console.log(
          "Category created successfully:",
          response.data.createAttendee
        );

        const newCategory = {
          id: values.name, // Use the name as ID since we're working directly with categories
          name: values.name,
        };

        onAddType(newCategory);
        resetForm();
        handleClose();
      } else {
        throw new Error("Response didn't include created category data");
      }
    } catch (error) {
      console.error("Error creating category:", error);
      setStatus({ success: false });
      setErrors({
        submit: error.message || "Failed to create category. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add New Category</DialogTitle>
      <Formik
        initialValues={{ name: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, touched, errors, values }) => (
          <Form>
            <DialogContent>
              <Field
                name="name"
                as={TextField}
                label="Category Name"
                fullWidth
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                autoFocus
              />
              {errors.submit && (
                <Box sx={{ mt: 2 }}>
                  <Typography color="error" variant="body2">
                    {errors.submit}
                  </Typography>
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} disabled={isSubmitting}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting || !values.name.trim()}
                color="primary"
                variant="contained"
              >
                {isSubmitting ? <CircularProgress size={24} /> : "Add"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default AddTypeDialog;
